import { PluginStore } from "graylog-web-plugin/plugin";
import { useState, useEffect } from "react";
export const isLocalNode = async (nodeId) => {
  var _a;
  const forwarderPlugin = PluginStore.exports("forwarder");
  const _isLocalNode = (_a = forwarderPlugin == null ? void 0 : forwarderPlugin[0]) == null ? void 0 : _a.isLocalNode;
  try {
    if (nodeId && _isLocalNode) {
      return _isLocalNode(nodeId);
    }
  } catch (_error) {
  }
  return true;
};
const useIsLocalNode = (nodeId) => {
  const [_isLocalNode, setIsLocalNode] = useState();
  useEffect(() => {
    const checkIsLocalNode = async () => {
      const result = await isLocalNode(nodeId);
      setIsLocalNode(result);
    };
    checkIsLocalNode().catch(() => setIsLocalNode(true));
  }, [nodeId, _isLocalNode]);
  return { isLocalNode: _isLocalNode };
};
export default useIsLocalNode;
